import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";

/**
 * @func api统一定义
 * @desc 添加 VUE_APP_BASE_API
 */
var api = {
  login: "newLogin",
  // sso-登陆   - 【已改】
  checkLogin: "checkCookie",
  // 检查用户是否已经登陆   - 【已改】
  send: "v1/sms/send-new",
  // 双因子-发送短信验证码
  authLogin: "authLogin",
  // 双因子-登录
  resetPasswordForce: "v2/user/resetPasswordForce",
  // 首登/弱改密-登录
  delayModifyPsw: "delayModifyPsw",
  // 弱改密-推迟改密
  createPictureCode: "v1/picture/createPictureCode",
  // 忘记密码---获取图片验证码,  【已改】
  getMessageCode: "v1/sms/getMessageCode ",
  // 忘记密码-获取短信验证码
  refreshPassword: "refreshPassword",
  // 忘记密码-提交手机号，图片验证码，短信验证码
  resetPassword: "resetPassword",
  // 忘记密码-重新提交,新密码  确认
  getNewPageParam: "getNewPageParam",
  // 新老兼容获取参数接口
  checkPwdWithOld: "checkPwdWithOld",
  // 校验老密码接口
  dxToken: "dingXiang/setEqIdToCookie",
  // 校验老密码接口
  getQr: "v3/qr/web/get",
  // 获取登录二维码    - 【已改】
  checkQr: "v3/qr/web/check",
  // 查询二维码结果    - 【已改】
  checkAccountType: "checkAccountType",
  // 查询是否是小天账户
  getAccountTypeByToken: "getAccountTypeByToken",
  // 根据url---token查询是否是小天账户
  modifyPassword: "v2/user/modifyPassword",
  // 登录态修改密码
  modifyPas: "v2/user/modifyPas",
  getCountryCode: "getCountryCode",
  // 获取国际区号    - 【已改】
  getVerificationCode: "common/mobile/validateCode/get",
  // 供应商注册获取验证码  【已改】
  supplierRegistration: "supplier/mobile/register",
  // 供应商注册
  loginByMobile: "byMobileCodeLogin",
  // 短信验证码登录 【已改】
  checkPictureCode: "v1/picture/checkPictureCode",
  // 图片验证码校验  【已改】
  getValidateCode: "v1/sms/getMessageCodeNew",
  // 忘记密码页获取短信验证码
  getSMCForMobileFix: "v1/sms/getSMCForMobileFix",
  // 外部账号绑定手机号获取短信验证码
  verifySMCForMobileFix: "v1/sms/verifySMCForMobileFix",
  // 外部账号绑定手机号确认接口
  refreshPasswordNew: "refreshPasswordNew",
  // 忘记密码页下一步验证码校验
  resetPasswordNew: "resetPasswordNew",
  // 忘记密码-重新提交,新密码(增加时间控制)
  newLogout: "newLogout",
  // 注销
  authLoginForWebSms: "authLoginForWebSms",
  // 双因子-登录-带国际区号
  getFaceQr: "face/qr/web/get",
  // 获取登录实人认证二维码
  checkFaceQr: "face/qr/web/check",
  // 查询登陆二维码结果
  getRegisterInfo: "v4/second-cert/get-register-info/web",
  // COE二次认证获取认证场景
  getSmsCode: "v4/sms/second-cert/get-sms-code/web",
  // COE二次认证获取短信验证码
  verifySmsCode: "v4/sms/second-cert/verify-sms-code/web",
  // COE验证二次认证短信验证码
  verifyLongKey: "v4/second-cert/verify-long-key",
  // COE二次认证校验龙key有效性
  getQrInfoWeb: "v4/second-cert/get-qr-info/web",
  // COE二次认证获取实人认证二维码
  verifyQrStatus: "v4/second-cert/verify-qr-status/web",
  // // COE二次认证获取实人认证二维码状态
  getFaceVerifyResult: "face/get-face-verify-result" // 获取是否需要二次认证

};
Object.keys(api).forEach(function (key) {
  api[key] = "".concat(process.env.VUE_APP_BASE_URL, "/").concat(api[key]);
});
export default api;